import { render, staticRenderFns } from "./SwitcherComponent.vue?vue&type=template&id=70554efe"
import script from "./SwitcherComponent.vue?vue&type=script&lang=ts"
export * from "./SwitcherComponent.vue?vue&type=script&lang=ts"
import style0 from "./SwitcherComponent.vue?vue&type=style&index=0&id=70554efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports